/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".navbar[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]{background:0 0;border:none;color:#046993}.navbar[_ngcontent-%COMP%]   .nav-item[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:hover{color:#19aa8d}"];
export { styles as styles };
